import { Text } from '@change/ds-core-ui/Text';

import { useDecisionMakerProfilePageData } from '#src/app/pages/decisionMaker/profile/pageContext';

export const EndorsementsOverview: React.FC = () => {
	const {
		data: { displayName, lastName, enrichedData },
	} = useDecisionMakerProfilePageData();

	const summary = enrichedData?.endorsementsOverview?.summary;
	const headingText = `Who's supporting ${lastName ?? displayName}?`;

	return !summary ? null : (
		<div data-qa="dm-endorsements-overview" className="flex flex-col gap-2">
			<Text as="h2" variant="heading" size="small" className="mb-2">
				{headingText}
			</Text>
			<Text variant="body">{summary}</Text>
		</div>
	);
};
